import React from "react";

const ContactCard = ({
  firstName,
  lastName,
  tags = [],
  phones = [],
  emails = [],
  jobTitle,
  company,
  notes,
  address,
  imageSourceProfile,
}) => {
  return (
    <div
      className="flex flex-col w-full relative items-center"
      id="contactCard"
    >
      <div
        className={`flex flex-col bg-white w-full items-start max-w-[90%] max-h-[40vh] shadow-xl overflow-hidden justify-between relative rounded-t-xl`}
      >
        <div className="flex flex-col w-full h-full bg-white overflow-auto pb-5 scrollbar-hide">
          <div className="flex flex-col w-full h-fit justify-start">
            <div
              className="w-full h-[100px] overflow-hidden"
              style={{
                backgroundColor: "#FF6500",
              }}
            />

            <div className="flex flex-row w-full justify-around items-center -mt-[65px]">
              {imageSourceProfile ? (
                <img
                  className="flex flex-col w-[130px] h-[130px] bg-gray-100 border-transparent border-4 rounded-full"
                  src={imageSourceProfile}
                  alt=""
                />
              ) : (
                <div className="flex flex-col w-[130px] h-[130px] bg-gray-100 border-transparent border-4 rounded-full"></div>
              )}
            </div>
          </div>

          <div className="flex flex-col w-full px-5 items-center gap-4 divide-y-2 divide-secondary mt-5">
            {firstName || lastName || jobTitle || company ? (
              <div className="flex flex-col w-full items-center">
                {firstName || lastName ? (
                  <div className="text-[22px] font-bold">
                    {(firstName || "") + " " + (lastName || "")}
                  </div>
                ) : null}
                {jobTitle || company ? (
                  <div className="text-[14px] text-gray-500">
                    {jobTitle ? jobTitle : "Job Title"}
                    {company ? " at " + company || "" : ""}
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className="flex flex-col w-full items-start pt-4 pb-2">
              {phones.map((val, ind) => {
                if (val.phone)
                  return (
                    <a
                      key={"phone" + ind}
                      className={`flex flex-row gap-2 justify-start items-center w-full text-wrap hover:bg-gray-100 p-2`}
                      target="_blank"
                    >
                      <img
                        src={
                          "https://cdn.nitomeyocard.com/asset/IMG2c37525234d0494ca0c167dbd72df75e.svg"
                        }
                        className="w-[40px] p-2 rounded-2xl"
                        style={{ backgroundColor: "#FF6500" }}
                      />
                      <div
                        className={`w-full truncate rounded p-2 cursor-pointer`}
                      >
                        {val.phone}
                      </div>
                    </a>
                  );
              })}
              {emails.map((val, ind) => {
                if (val.email)
                  return (
                    <a
                      key={"email" + ind}
                      className={`flex flex-row gap-2 justify-start items-center w-full text-wrap hover:bg-gray-100 p-2`}
                      target="_blank"
                    >
                      <img
                        src={`https://cdn.nitomeyocard.com/asset/IMG3fc615fefaf54b07b630877d32847e07.svg`}
                        className="w-[40px] p-2 rounded-2xl"
                        style={{ backgroundColor: "#FF6500" }}
                      />
                      <div
                        className={`w-full truncate rounded p-2 cursor-pointer`}
                      >
                        {val.email}
                      </div>
                    </a>
                  );
              })}
              {address && (
                <>
                  <a
                    className={`flex flex-row gap-2 justify-start items-center w-full text-wrap hover:bg-gray-100 p-2`}
                    target="_blank"
                  >
                    <img
                      src={`https://cdn.nitomeyocard.com/asset/IMG6a34edb9254d4343b0160bd3acca421c.svg`}
                      className="w-[40px] p-2 rounded-2xl"
                      style={{ backgroundColor: "#FF6500" }}
                    />
                    <div
                      className={`w-full truncate rounded p-2 cursor-pointer`}
                    >
                      {address}
                    </div>
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`flex flex-col bg-white w-full items-start max-w-[90%] max-h-[30vh] shadow-xl scrollbar-hide overflow-y-auto overflow-hidden justify-between relative rounded-b-xl mt-2`}
      >
        <div className="flex flex-col w-full p-5 items-start gap-4 divide-secondary">
          <div className="flex flex-col w-full gap-2">
            <div className="font-bold">Tags</div>
            <div className="flex flex-row flex-wrap gap-2">
              {tags.map((val, ind) => (
                <span
                  className="flex flex-col px-3 py-1 bg-tertiary rounded-lg w-fit text-black"
                  key={ind}
                >
                  {val}
                </span>
              ))}
            </div>
          </div>
          <div className="flex flex-col w-full gap-2">
            <div className="font-bold">Notes</div>
            <textarea
              className="bg-white resize-none rounded-lg border p-2"
              rows={5}
              disabled={true}
              value={notes}
            />
          </div>
        </div>
        <div className="flex flex-col h-[20px] w-full bg-primary"></div>
      </div>
    </div>
  );
};

export default ContactCard;
